import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetHarmfulFactorDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { HarmfulFactorCategoryText } from '../../../common/spdCore/validation/schemas';

interface HarmfulFactorProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const harmfulFactorForGrid = (harmfulFactor: GetHarmfulFactorDto) => {
  return {
    key: harmfulFactor.id,
    values: {
      'harmfulFactor.systemNumber': harmfulFactor.systemNumber,
      'harmfulFactor.name': harmfulFactor.name,
      'harmfulFactor.description': harmfulFactor.description,
      'harmfulFactor.active': harmfulFactor.active ? 'Tak' : 'Nie',
      'harmfulFactor.category': harmfulFactor?.category
        ? HarmfulFactorCategoryText[harmfulFactor?.category]
        : '',
      'test.name': harmfulFactor?.harmfulFactorTests
        ?.map(o => o?.test?.name)
        .join(', '),
      'supportingExaminationDict.name': harmfulFactor?.harmfulFactorSupports
        ?.map(o => o?.supportingExaminationDict?.name)
        .join(', '),
    },
    isInactive: !harmfulFactor.active,
  };
};

export const HarmfulFactorSearch: React.FC<HarmfulFactorProps> = props => {
  const columns = [
    { header: 'Lp', property: 'harmfulFactor.systemNumber' },
    { header: 'Nazwa', property: 'harmfulFactor.name' },
    { header: 'Opis', property: 'harmfulFactor.description' },
    { header: 'Kategoria', property: 'harmfulFactor.category' },
    { header: 'Testy', property: 'test.name' },
    {
      header: 'Badania pomocnicze',
      property: 'supportingExaminationDict.name',
    },
    { header: 'Aktywny', property: 'harmfulFactor.active' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      onRowClick={props.onRowClick}
      initialOrderColumn="harmfulFactor.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak czynników szkodliwych w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      showExport={true}
    />
  );
};
